import styled from 'styled-components';
import { Flex } from '@elementary/common-ui/components';
import { WarehouseType } from '@elementary/common-ui/types';
import { UseFormReturn } from 'react-hook-form';
import { AddTestForm, ColumnResource, Resource } from 'shared/types';
import WizardConfigurationStage from './WizardConfigurationStage';
import WizardReviewStage from './WizardReviewStage';
import WizardStage from './WizardStage';
import WizardTargetStage from './WizardTargetStage';
import WizardTestStage from './WizardTestStage/WizardTestStage';

const Wrapper = styled(Flex)`
  height: 100%;
  overflow: auto;
`;

type Props = {
  methods: UseFormReturn<AddTestForm, any, undefined>;
  stage: number;
  tableResourcesData: Resource[];
  columnsResourcesData: ColumnResource[];
  keepConfigStageMounted: boolean;
  isResourcesLoading?: boolean;
  warehouseType?: WarehouseType;
};

const AddTestWizardStages = ({
  methods,
  stage,
  tableResourcesData,
  columnsResourcesData,
  keepConfigStageMounted,
  isResourcesLoading,
  warehouseType,
}: Props) => (
  <Wrapper>
    <WizardStage $index={1} $selectedIndex={stage}>
      <WizardTargetStage
        control={methods.control}
        tableResourcesData={tableResourcesData}
        columnsResourcesData={columnsResourcesData}
        isLoading={isResourcesLoading}
      />
    </WizardStage>

    <WizardStage $index={2} $selectedIndex={stage}>
      <WizardTestStage
        watch={methods.watch}
        setValue={methods.setValue}
        tableResourcesData={tableResourcesData}
        columnsResourcesData={columnsResourcesData}
        warehouseType={warehouseType}
      />
    </WizardStage>

    {keepConfigStageMounted && (
      <WizardStage $index={3} $selectedIndex={stage}>
        <WizardConfigurationStage
          methods={methods}
          columnsResourcesData={columnsResourcesData}
          tableResourcesData={tableResourcesData}
        />
      </WizardStage>
    )}

    {stage === 4 && (
      <WizardStage $index={4} $selectedIndex={stage}>
        <WizardReviewStage
          watch={methods.watch}
          tableResourcesData={tableResourcesData}
          columnsResourcesData={columnsResourcesData}
        />
      </WizardStage>
    )}
  </Wrapper>
);

export default AddTestWizardStages;
